export const sessionStaticData = {
  sessionOverviewText: 'Sessions Overview',
  upcomingTabText: 'Upcoming',
  completedTabText: 'Completed',
  cancelledTabText: 'Cancelled',
  studentNameText: 'Student Name',
  dateText: 'Date',
  timingText: 'Timing',
  subjectText: 'Subject',
  sessionTypeText: 'Session Type',
  actionsText: 'Actions',
  viewDetailsText: 'View Details',
  rescheduleText: 'Reschedule',
  cancelSessionText: 'Cancel Session',
  reportIssueText: 'Report issue',
};

export const sessionHindiData = {
  sessionOverviewText: 'सत्र अवलोकन',
  upcomingTabText: 'आगामी',
  completedTabText: 'पूर्ण',
  cancelledTabText: 'रद्द',
  studentNameText: 'छात्र का नाम',
  dateText: 'दिनांक',
  timingText: 'समय',
  subjectText: 'विषय',
  sessionTypeText: 'सत्र का प्रकार',
  actionsText: 'कार्रवाई',
  viewDetailsText: 'विवरण देखें',
  rescheduleText: 'पुनः निर्धारित करें',
  cancelSessionText: 'सत्र रद्द करें',
  reportIssueText: 'समस्या की रिपोर्ट करें',
};

export const sessionArabicData = {
  sessionOverviewText: 'نظرة عامة على الجلسات',
  upcomingTabText: 'القادمة',
  completedTabText: 'مكتملة',
  cancelledTabText: 'ملغاة',
  studentNameText: 'اسم الطالب',
  dateText: 'التاريخ',
  timingText: 'التوقيت',
  subjectText: 'المادة',
  sessionTypeText: 'نوع الجلسة',
  actionsText: 'الإجراءات',
  viewDetailsText: 'عرض التفاصيل',
  rescheduleText: 'إعادة جدولة',
  cancelSessionText: 'إلغاء الجلسة',
  reportIssueText: 'الإبلاغ عن مشكلة',
};
